import React from 'react';
import Dashboard from './Dashboard';
import JobsOverview from './JobsOverview';
const RequesterDashboard = ({ status }) => {
    return React.createElement(Dashboard, { status: status },
        React.createElement(JobsOverview, { status: status }));
};
export default RequesterDashboard;
